export default __webpack_public_path__ + "static/media/flight.6bb94c69.svg";